"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Collapse = _interopRequireDefault(require("../../../Collapse/Collapse"));
var BasicCardCollapse = function BasicCardCollapse(_ref) {
  var heading = _ref.heading,
    subheading = _ref.subheading,
    whiteFont = _ref.whiteFont,
    children = _ref.children,
    on = _ref.on,
    toggle = _ref.toggle;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "card--basic collapse d8-u-relative flex flex-column justify-between height-100%"
  }, /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
    on: on,
    toggle: toggle,
    noPadding: true,
    heading: /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-component"
    }, heading && /*#__PURE__*/_react["default"].createElement("h3", {
      className: (0, _classnames["default"])('card--basic__heading', 'd8-u-ls-sm', 'text-md', whiteFont && 'd8-u-color-white')
    }, heading), subheading && /*#__PURE__*/_react["default"].createElement("p", {
      className: (0, _classnames["default"])('text-sm', whiteFont && 'd8-u-color-white', 'd8-u-color-contrast-high')
    }, subheading))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "collapse--wrapper"
  }, children)));
};
BasicCardCollapse.propTypes = {
  heading: _propTypes["default"].string,
  subheading: _propTypes["default"].string,
  whiteFont: _propTypes["default"].bool,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  on: _propTypes["default"].bool.isRequired,
  toggle: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = BasicCardCollapse;